import type { Fetcher } from "react-query-kit";
import { createQuery } from "react-query-kit";

import type { IPickCollectionQuery } from "../../types";
import { getApi } from "../../apiPath";
import { axiosClient } from "../../clients";

import type { IMemberBookType } from "./routeType";

const { key, getPath } = getApi("types.memberBook.getAll");

type IExtractedRouteType = IMemberBookType["MemberBookTypeCollectionRetrieve"];

export type IGetMemberBookType = IPickCollectionQuery<IExtractedRouteType>;

const getMemberBookType: Fetcher<
  IGetMemberBookType["response"],
  IGetMemberBookType["variables"]
> = (params) => {
  return axiosClient.get(getPath(), { params });
};

export const useGetMemberBookType = createQuery({
  queryKey: [key],
  fetcher: getMemberBookType,
});
